export default {
      id: "feuille_titres-usage",
      viewBox: "0 0 20 22",
      url: "../dist/images/" + "sprite.svg#feuille_titres-usage",
      toString: function () {
        return this.url;
      }
    }